module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/wearing/wearing-10-e5250d2533f74f4d3f196ed2a8d766ae.jpg";